import React from "react";

type Props = {
  icon: string;
  status?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const ButtonIcon: React.FC<Props> = ({
  icon,
  status,
  onClick,
}): JSX.Element => {
  return (
    <button
      style={{
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "16px",
        gap: "12px",
        width: "56px",
        height: "56px",
        background: "#FFFFFF",
        border: status === true ? "1px solid #408E5A" : "1px solid #D6D6D6",
        borderRadius: "6px",
        flex: "none",
        order: 0,
        flexGrow: 0,
      }}
      type="button"
      onClick={onClick}
    >
      <img src={icon} alt="icon" width={24} height={24} />
    </button>
  );
};

export default ButtonIcon;
